import * as interfaces from "../../interfaces";
import DslElementType from "../../enums/DslElementType";
import { LocationProvider } from "../../../../monaco-helpers";
import * as helpers from "../helpers";
import { Expression } from "./Expression";
import { RawElement } from "../common";

export class LocalVariableExpression extends Expression implements interfaces.ILocalVariableExpression {
  elementType: DslElementType.LocalVariableExpression = DslElementType.LocalVariableExpression;
  variable: RawElement<string>;

  constructor(obj: interfaces.ILocalVariableExpression, locationProvider?: LocationProvider) {
    super(obj, locationProvider);
    this.variable = helpers.ensureIsInstance(obj.variable, RawElement<string>);
  }
  toJson(): interfaces.ILocalVariableExpression {
    return {
      isExpression: true,
      elementType: this.elementType,
      location: this.location,
      variable: this.variable.toJson(),
    };
  }
  toDsl(indent: number): string {
    return this.variable.value;
  }
}
